import { doc, type Firestore, type Transaction } from 'firebase/firestore';
import type { Destination, TripConfig } from '../types';
import { removeDestination, type RemovalStore } from '../../functions/src/destinationRemovalPolicy.mjs';

// The rules live in functions/src/destinationRemovalPolicy.mts, shared with the
// server's changeTripRoute 'remove' (which also checks every branch).
export { transportDestination } from '../../functions/src/destinationRemovalPolicy.mjs';

const clientStore = (transaction: Transaction, db: Firestore): RemovalStore => ({
  get: async path => { const s = await transaction.get(doc(db, path)); return { exists: s.exists(), data: () => s.data() }; },
  set: (path, data, merge) => { transaction.set(doc(db, path), data, { merge }); },
  update: (path, data) => { transaction.update(doc(db, path), data); },
  delete: path => { transaction.delete(doc(db, path)); },
});

/** One atomic deletion; never delete financial records or another visit's content. */
export async function writeDestinationRemoval(transaction: Transaction, db: Firestore, input: {
  tripId: string; previous: TripConfig; destination: Destination;
  dayDates: string[]; scheduleIds: string[]; userId: string;
}): Promise<TripConfig> {
  const { latest, destinations, accommodations } = await removeDestination(clientStore(transaction, db), {
    ...input, now: new Date().toISOString(),
  });
  return { ...input.previous, ...latest, id: input.tripId, destinations, accommodations } as TripConfig;
}
